<div class="container">
  <div class="metadata-container" *ngIf="!isLoading">
    <div class="security-container">
      <!-- COUNTRY -->
      <mat-progress-bar
        mode="indeterminate"
        *ngIf="isSecurityLoading"
      ></mat-progress-bar>
      <div>
        <h3 class="section-title">
          Country Access
          <span *ngIf="!user.isSuperAdmin">
              <i-feather
                class="info-icon"
                name="info"
                matTooltip="Contact maxisfor3rdparties@gm.com to update country access."
                [matTooltipClass]="'tooltipClass'"
              ></i-feather>
          </span>
        </h3>
        <mat-list role="list">
          <mat-list-item *ngFor="let country of report.countries">
            <mat-checkbox
              class="checkbox"
              [(ngModel)]="country.hasAccess"
              (change)="setChangesMade()"
              [disabled]="!user.isSuperAdmin"
            >
            </mat-checkbox>
            {{ country.fullName }}
          </mat-list-item>
        </mat-list>
      </div>
    </div>
    <div class="form">
      <h3>Report Ownership</h3>
      <div class="ownership-help">Input a users GMID or email to add them</div>
      <div *ngIf="saveError.includes('ASMS')" class="custom-error">
        ASMS required, must be a valid ASMS
      </div>
      <mat-form-field class="small-input">
        <mat-label>ASMS</mat-label>
        <input
          matInput
          [(ngModel)]="report.asms"
          (ngModelChange)="setChangesMade()"
        />
      </mat-form-field>
      <div *ngIf="saveError.includes('Report Owner')" class="custom-error">
        User GMID or email not found
      </div>
      <div *ngIf="saveError.includes('Owner required')" class="custom-error">
        Report owner required
      </div>
      <mat-form-field class="small-input">
        <mat-label>Report Owner</mat-label>
        <input
          matInput
          [(ngModel)]="report.reportOwnerQuery"
          (ngModelChange)="setChangesMade()"
        />
      </mat-form-field>
      <div *ngIf="saveError.includes('Business')" class="custom-error">
        User GMID or email not found
      </div>
      <mat-form-field class="small-input">
        <mat-label>Business Owner</mat-label>
        <input
          matInput
          [(ngModel)]="report.businessOwnerQuery"
          (ngModelChange)="setChangesMade()"
        />
      </mat-form-field>
      <div *ngIf="saveError.includes('Operations')" class="custom-error">
        User GMID or email not found
      </div>
      <mat-form-field class="small-input">
        <mat-label>Operations Owner</mat-label>
        <input
          matInput
          [(ngModel)]="report.operationsOwnerQuery"
          (ngModelChange)="setChangesMade()"
        />
      </mat-form-field>
      <div *ngIf="saveError.includes('Innovation')" class="custom-error">
        User GMID or email not found
      </div>
      <mat-form-field class="small-input">
        <mat-label>Innovation Owner</mat-label>
        <input
          matInput
          [(ngModel)]="report.innovationOwnerQuery"
          (ngModelChange)="setChangesMade()"
        />
      </mat-form-field>
      <!-- <div>Report added to Maxis for Dealers by {{report.reportCreator.name}}</div> -->
    </div>
    <div>
      <h3>Report Name</h3>
      <mat-form-field class="small-input">
        <mat-label>Name</mat-label>
        <input
          matInput
          [(ngModel)]="report.name"
          name="name"
          (ngModelChange)="setChangesMade()"
        />
      </mat-form-field>
      <div>
        <div *ngIf="report.reportType === 'cognos'">
          <h3 class="section-title">
            Report Link
            <span *ngIf="!user.isSuperAdmin">
                <i-feather
                  class="info-icon"
                  name="info"
                  matTooltip="Contact maxisfor3rdparties@gm.com to update report link."
                  [matTooltipClass]="'tooltipClass'"
                ></i-feather>
            </span>
          </h3>
          <mat-form-field class="small-input">
            <mat-label>URL</mat-label>
            <input
              matInput
              [(ngModel)]="report.url"
              name="name"
              (ngModelChange)="setChangesMade()"
              [disabled]="!user.isSuperAdmin"
            />
          </mat-form-field>
        </div>
        <div *ngIf="report.reportType === 'pbi'">
          <h3 class="section-title">
            Report ID
            <i-feather
              *ngIf="!user.isSuperAdmin"
              class="info-icon"
              name="info"
              matTooltip="Contact maxisfor3rdparties@gm.com to update report ID"
              [matTooltipClass]="'tooltipClass'"
            ></i-feather>
          </h3>
          <mat-form-field class="small-input">
            <mat-label>ID</mat-label>
            <input
              matInput
              [(ngModel)]="report.reportGuidPbi"
              name="reportGuidPbi"
              (ngModelChange)="setChangesMade()"
              [disabled]="!user.isSuperAdmin"
            />
          </mat-form-field>
          <h3 class="section-title">
            Report Dataset ID
            <span *ngIf="!user.isSuperAdmin">
                <i-feather
                  class="info-icon"
                  name="info"
                  matTooltip="Contact maxisfor3rdparties@gm.com to update report dataset ID."
                  [matTooltipClass]="'tooltipClass'"
                ></i-feather>

            </span>
          </h3>
          <mat-form-field class="small-input">
            <mat-label>ID</mat-label>
            <input
              matInput
              [(ngModel)]="report.datasetId"
              name="datasetId"
              (ngModelChange)="setChangesMade()"
              [disabled]="!user.isSuperAdmin"
            />
          </mat-form-field>
          <h3 class="section-title">
            Report Workspace ID
            <span *ngIf="!user.isSuperAdmin">
                <i-feather
                  class="info-icon"
                  name="info"
                  matTooltip="Contact maxisfor3rdparties@gm.com to update report workspace ID."
                  [matTooltipClass]="'tooltipClass'"
                ></i-feather>
            </span>
          </h3>
          <mat-form-field class="small-input">
            <mat-label>ID</mat-label>
            <input
              matInput
              [(ngModel)]="report.workspaceId"
              name="workspaceId"
              (ngModelChange)="setChangesMade()"
              [disabled]="!user.isSuperAdmin"
            />
          </mat-form-field>
        </div>
      </div>
      <h3>Report Description</h3>
      <div *ngIf="saveError.includes('Description')" class="custom-error">
        Description required. Must be atleast 40 characters
      </div>
      <mat-form-field appearance="none" class="large-input">
        <textarea
          matInput
          [(ngModel)]="report.description"
          name="description"
          maxlength="180"
          (ngModelChange)="setChangesMade()"
          class="description-input"
        ></textarea>
      </mat-form-field>
      <div class="text-length helptext">
        {{ report.description.length }} / 180
      </div>
    </div>
    <div class="icon-flex">
      <h3>Report Icon</h3>
      <div class="icon-container">
        <mat-spinner *ngIf="isIconLoading"></mat-spinner>
        <img [src]="report.iconBase64" *ngIf="!isIconLoading" />
      </div>
      <button mat-raised-button color="accent" (click)="addFile()">
        Upload Image
      </button>
      <input
        type="file"
        #file
        style="display: none"
        (change)="handleFileUpload()"
        multiple
        (ngModelChange)="setChangesMade()"
      />
    </div>
  </div>
  <mat-spinner class="loading-spinner" *ngIf="isLoading"></mat-spinner>
  <div *ngIf="saveError" class="custom-error">
    Failed to save, please fix issues above and try again.
  </div>
  <div class="button-container" *ngIf="!isLoading">
    <button mat-raised-button class="close-btn" routerLink="/reports/manage">
      Close
    </button>
    <button
      mat-raised-button
      color="accent"
      (click)="saveChanges()"
      [disabled]="!changeMade"
    >
      Save
    </button>
  </div>
</div>
